<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <!-- <div *ngIf="shop.coverUrl" class="logo-bill">
        <img width="100" [src]="shop.coverUrl" alt="" />
      </div> -->

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4>
              CÔNG NỢ CHI TIẾT
              {{ mode === "customer" ? "KHÁCH HÀNG" : "NHÀ CUNG CẤP" }}
            </h4>
          </td>
        </tr>
        <tr *ngIf="fromDate && toDate">
          <td style="text-align: center">
            <label>
              Từ ngày:
              {{ fromDate | date : "dd/MM/yyyy " }}
              đến ngày:
              {{ toDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <table
              width="100%"
              style="border: 0px"
              cellpadding="0"
              cellspacing="0"
            >
              <tr>
                <td style="text-align: left; width: 60%">
                  <label>
                    <strong>
                      {{ mode === "customer" ? "Khách hàng" : "Nhà cung cấp" }}
                      :
                    </strong>
                    {{ object.fullName }}
                  </label>
                </td>
                <td style="text-align: left; width: 40%">
                  <label> <strong> ĐT: </strong> {{ object.mobile }} </label>
                </td>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left">
                  <strong> {{ "common.address" | translate }} : </strong>
                  {{ object.address }}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table #exportTable class="table-detail">
        <thead>
          <tr style="text-align: center">
            <th>
              <strong> {{ "common.no" | translate }} </strong>
            </th>
            <th>
              <strong> Ngày </strong>
            </th>
            <th>
              <strong> Mã hàng </strong>
            </th>
            <th>
              <strong> {{ "product.name" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "product.unit" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.quantity" | translate }} </strong>
            </th>
            <th>
              <strong> {{ "common.unitPrice" | translate }} </strong>
            </th>
            <th>
              <strong> Chiết khấu </strong>
            </th>
            <th>
              <strong> {{ "common.totalAmount" | translate }} </strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="9" style="text-align: left">
              <strong>
                CHI TIẾT {{ mode === "customer" ? "BÁN HÀNG" : "MUA HÀNG" }}
              </strong>
            </td>
          </tr>
          <tr *ngFor="let item of deptDetail; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span *ngIf="item.productCode !== 'ĐK'">{{
                item.issueDate | date : "dd/MM/yyyy"
              }}</span>
            </td>
            <td style="text-align: left">
              <label>
                {{ item.productCode }}
              </label>
            </td>
            <td style="text-align: left">
              <label>
                {{ item.productName }}
                <span *ngIf="item.comment">( {{ item.comment }} )</span>
              </label>
            </td>
            <td style="text-align: left">
              <label>
                {{ item.productUnitName }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.quantity | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                {{ item.price | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              <label>
                <span *ngIf="item.discountPercent > 0"
                  >{{ item.discountPercent }}% :</span
                >
                {{ item.discountAmount | number : 0 }}
              </label>
            </td>
            <td style="text-align: right">
              {{ item.amount | number : 0 }}
            </td>
          </tr>

          <tr *ngIf="paymentDebits.length > 0">
            <td colspan="9" style="text-align: left">
              <strong> CHI TIẾT THANH TOÁN </strong>
            </td>
          </tr>
          <tr *ngFor="let item of paymentDebits; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.issueDate | date : "dd/MM/yyyy" }}</td>
            <td colspan="6" style="text-align: left">
              <p>
                {{ item.note }}
              </p>
            </td>
            <td style="text-align: right">
              {{ item.paid | number : 0 }}
            </td>
          </tr>

          <tr>
            <td colspan="9" style="text-align: left">
              <strong> TỔNG CỘNG </strong>
            </td>
          </tr>
          <tr *ngIf="discountAmount !== 0">
            <td colspan="8" style="text-align: right">
              <strong> TỔNG TIỀN HÀNG: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ saleAmount + discountAmount | number : 0 }} </strong>
            </td>
          </tr>
          <tr *ngIf="discountAmount !== 0">
            <td colspan="8" style="text-align: right">
              <strong> TỔNG CHIẾT KHẤU HĐ: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ discountAmount | number : 0 }} </strong>
            </td>
          </tr>

          <tr>
            <td colspan="8" style="text-align: right">
              <strong> PHÁT SINH NỢ: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ saleAmount | number : 0 }} </strong>
            </td>
          </tr>

          <tr *ngIf="initAmount !== 0">
            <td colspan="8" style="text-align: right">
              <strong>NỢ CŨ: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ initAmount | number : 0 }} </strong>
            </td>
          </tr>

          <tr>
            <td colspan="8" style="text-align: right">
              <strong> THANH TOÁN: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ paidAmount | number : 0 }} </strong>
            </td>
          </tr>

          <tr>
            <td colspan="8" style="text-align: right">
              <strong> NỢ CÒN LẠI: </strong>
            </td>
            <td style="text-align: right">
              <strong> {{ initAmount + debitAmount | number : 0 }} </strong>
            </td>
          </tr>
        </tbody>

        <tfoot></tfoot>
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="2" class="height-1"></td>
        </tr>
        <tr>
          <td></td>
          <td style="text-align: center">
            <span>
              Ngày {{ currentDate | date : "dd " }} tháng
              {{ currentDate | date : "MM " }} năm
              {{ currentDate | date : "yyyy " }}</span
            >
          </td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong>Khách hàng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
